import React from 'react';
import styled from 'styled-components';
import { useMutation } from '@tanstack/react-query';
import { LabsWalletCancelRechargeAPI } from '../Apis/PlimoneyApis';

// 스타일 컴포넌트
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #ededed;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const CloseIcon = styled.div`
  cursor: pointer;
  font-size: 20px;
  color: #999;
`;

const ModalBody = styled.div`
  padding: 30px;
`;

const InfoContainer = styled.div`
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 25px;
  margin-bottom: 20px;
`;

const InfoSection = styled.div`
  margin-bottom: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const InfoLabel = styled.div`
  font-size: 14px;
  color: #2282e9;
  margin-bottom: 8px;
  font-weight: 500;
`;

const InfoValue = styled.div`
  font-size: 14px;
  color: #333;
  font-weight: 500;
`;

const InfoNote = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 5px;
`;

const CancelButton = styled.button`
  width: 100%;
  height: 50px;
  border-radius: 50px;
  background-color: #18191a;
  color: white;
  font-weight: 600;
  border: none;
  cursor: pointer;
  font-size: 16px;
`;

// 성공 모달 스타일 컴포넌트 추가
const SuccessModalOverlay = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1100;
`;

const SuccessModal = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 20px 40px;
  border-radius: 8px;
  font-size: 16px;
  text-align: center;
`;

interface CancelChargeModalProps {
  onClose: () => void;
  onCancel: () => void;
  chargeInfo: {
    backName: string;
    rechargeId: number;
    accountNumber: string;
    accountHolder: string;
    amount: number;
    dueDate: string;
  };
}

const CancelChargeModal: React.FC<CancelChargeModalProps> = ({
  onClose,
  onCancel,
  chargeInfo
}) => {
  // 금액 형식화 (1000 -> 1,000)
  const formatAmount = (amount: number) => {
    return amount.toLocaleString();
  };
  
  console.log('chargeInfo: ',chargeInfo);

  const [showSuccessModal, setShowSuccessModal] = React.useState(false);

  const cancelRechargesMutation = useMutation({
    mutationFn: () => LabsWalletCancelRechargeAPI(chargeInfo.rechargeId),
    onSuccess: () => {
      setShowSuccessModal(true);
      setTimeout(() => {
        setShowSuccessModal(false);
        onClose();
        window.location.reload();
      }, 2000);
    },
    onError: (error) => {
      console.error('충전 취소 요청 실패:', error);
      alert('충전 취소 요청에 실패했습니다. 다시 시도해주세요.');
    }
  });

  // 취소하기 버튼 클릭 핸들러
  const handleCancelCharge = () => {
    cancelRechargesMutation.mutate();
  };

  return (
    <ModalOverlay>
      {showSuccessModal && (
        <SuccessModalOverlay>
          <SuccessModal>
            충전 취소 요청이 완료되었습니다
          </SuccessModal>
        </SuccessModalOverlay>
      )}
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>플리머니 충전 취소 요청</ModalTitle>
          <CloseIcon onClick={onClose}>✕</CloseIcon>
        </ModalHeader>
        <ModalBody>
          <InfoContainer>
            <InfoSection>
              <InfoLabel>계좌 정보</InfoLabel>
              <InfoValue>{chargeInfo.backName} {chargeInfo.accountNumber}</InfoValue>
              <InfoValue>예금주: {chargeInfo.accountHolder}</InfoValue>
            </InfoSection>

            <InfoSection>
              <InfoLabel>결제 금액</InfoLabel>
              <InfoValue>{formatAmount(chargeInfo.amount)}원</InfoValue>
            </InfoSection>
            
            <InfoSection>
              <InfoLabel>입금 기한</InfoLabel>
              <InfoValue>{chargeInfo.dueDate} 까지</InfoValue>
              <InfoNote>(기한내 미 입금시 자동 취소 됩니다.)</InfoNote>
            </InfoSection>
          </InfoContainer>
          
          <CancelButton onClick={handleCancelCharge}>
            충전 취소하기
          </CancelButton>
        </ModalBody>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default CancelChargeModal; 